/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelachiever3Inputs */



/**
* | output |
* | --- |
* | "The Goal Slayer" |
*
* @param {Personalityarchetypelabelachiever3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelachiever3 = /** @type {((inputs?: Personalityarchetypelabelachiever3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelachiever3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Goal Slayer")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Conquistador de Metas")
	return /** @type {LocalizedString} */ ("Целеубийца")
});
export { personalityarchetypelabelachiever3 as "personalityArchetypeLabelAchiever" }